import { MyThemeModel } from './../models/Cms/MyThemeModel';
import { MyContentModel } from './../models/Cms/MyContentModel';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LanguageModel } from './../models/LanguageModel';
import { ResourceService } from 'src/app/services/resource.service';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';
import { BehaviorSubject } from 'rxjs';
import { RentalServiceDeliveryChannel } from '../models/enums/Payments/PaymnetsEnum';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
  selectedLanguage: LanguageModel;
  selectedLanguageIsoCode;

  private _contentModel = new BehaviorSubject<MyContentModel>(null);
  readonly contentModel = this._contentModel.asObservable();

  private dataStore: {contentModel: MyContentModel} = {contentModel: null,};

  constructor(private http: HttpClient, private resouceService: ResourceService) {


    //Default isocode
    this.selectedLanguageIsoCode = "en";
    resouceService.selectedLanguage.subscribe(res => {

      this.selectedLanguage = res;
      if (res != null) {
        this.selectedLanguageIsoCode = res.isoCode2;
      }
    })

    let _cachedCms=this.getCachedCMSContent();
    if(_cachedCms!=null){
      this.updateConentModel(_cachedCms);
    }

  }


  getMyContent() {
    return this.http.get<MyContentModel>(ApiControllerActionEnum.GetMyContent + `?rentalServiceDeliveryChannel=${RentalServiceDeliveryChannel.Online}&?&lang=${this.selectedLanguageIsoCode}`)
  }

  loadContent() {

    return new Promise((resolve, reject) => {


       let lang=this.resouceService.getCachedSelectedLanguage();
       if(lang!=null){
         this.selectedLanguageIsoCode=lang.isoCode2;
       }
      this.http.get<MyContentModel>(ApiControllerActionEnum.GetMyContent +`?rentalServiceDeliveryChannel=${RentalServiceDeliveryChannel.Online}&?&lang=${this.selectedLanguageIsoCode}` ).subscribe(res => {

        this.updateConentModel(res);

        resolve(true);
      },err =>{
        resolve(false);
      })
    })
  }


  getMyTheme() {
    return this.http.get<Array<MyThemeModel>>(ApiControllerActionEnum.GetMyTheme + `?&lang=${this.selectedLanguageIsoCode}`)
  }

  updateConentModel(model) {
    this.dataStore.contentModel = model;
    this._contentModel.next(Object.assign({}, this.dataStore).contentModel);
    localStorage.setItem("cmsContent",JSON.stringify(model));
  }
  getCachedCMSContent(){
    return JSON.parse(localStorage.getItem("cmsContent"))
  }


}
